<template>
  <div class="radar" style="z-index: 666">
    <div v-resize="resizeChart" :id="radarId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../../utils/util";

  export default {
    name: 'radar',
    props: {
      radarId: {
        type: String,
        default () {
          return 'radarId'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '100%'
        }
      },
      radarTitle: {
        type: String,
        default () {
          return ''
        }
      },
      titleStyle: {
        type: Object,
        default () {
          return  {}
        }
      },
      radarColor: {
        type: Array,
        default () {
          return []
        }
      },
      legendData: {
        type: Object,
        default () {
          return  {}
        }
      },
      radarAxisData: {
        type: Array,
        default () {
          return []
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        radar: null
      }
    },
    mounted () {
      this.drawRadar()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    directives:{
      resize: { // 指令的名称
        bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
          console.log(el,"绑定",binding);
          let width = '', height = '';
          function isReize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
              binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
            }
            width = style.width;
            height = style.height;
          }
          el.__vueSetInterval__ = setInterval(isReize, 300);
        },
        unbind(el) {
          console.log(el,"解绑");
          clearInterval(el.__vueSetInterval__);
        }
      }
    },
    methods: {
      drawRadar () {
        this.radar = this.$echarts.init(document.getElementById(this.radarId))
        this.radar.setOption({
          title: {
            show: false,
            text: this.radarTitle,
            textStyle: this.titleStyle
          },
          tooltip: {
            trigger: 'item',
            position: 'bottom'
          },
          color: this.radarColor,
          legend: this.legendData,
          radar: this.radarAxisData,
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.radar.resize()
      }, 100),
    },
    watch: {
      series (val) {
        this.drawRadar()
      }
    }
  }
</script>

<style scoped>
  .radar {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Radar/Radar.vue